<template lang="pug">
.itemProgressBook
  ui-progress-bar(
    :percent-completed="childItem.progress"
  )
</template>

<script>
import ChildBook from '@/models/ChildBook'
export default {
  props: {
    childItem: {
      type: ChildBook,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.itemProgressBook
  width: 100%
</style>
